import type { TOC } from '@ember/component/template-only';

import type { GradientPresetName } from '@databox/icons/dist/types';

export interface CommonUiIconInterface {
	Element: HTMLElement;
	Args: {
		name: IconName;
		size?: IconSize;
		fill?: string;
		stroke?: string;
		class?: string;
		gradient?: GradientPresetName;
	};
}

const CommonUiIcon: TOC<CommonUiIconInterface> = <template>
	<ui-icon
		name={{@name}}
		size={{@size}}
		fill={{@fill}}
		stroke={{@stroke}}
		class={{@class}}
		gradient={{@gradient}}
	></ui-icon>
</template>;

export default CommonUiIcon;
